import ClaimsOperationIcon, {
	Sign,
} from 'components/commons/ClaimIcons/ClaimsOperationIcon.component';
import { useClaimHook } from 'hooks/claim.hook';
import { TableCell, TableHead, TableRow, Typography } from 'styles';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';

const ClaimPaymentsHeader = () => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});
	const { showTaxColumns } = useClaimHook();

	return (
		<TableHead>
			<TableRow
				sx={{
					'& > th': {
						whiteSpace: 'nowrap',
					},
					'& > th:first-of-type': {
						pl: '20px!important',
					},
					'& > th:last-of-type': {
						pr: '20px!important',
					},
				}}
			>
				<TableCell>
					<Typography variant="value1">
						{tClientLabels('claim.table.serviceDate')}
					</Typography>
				</TableCell>
				<TableCell align="center">
					<Typography variant="value1">
						{tClientLabels('claim.table.serviceCode')}
					</Typography>
				</TableCell>
				<TableCell align="center">
					<Typography variant="value1">{tClientLabels('claim.table.st')}</Typography>
				</TableCell>
				<TableCell align="center">
					<Typography variant="value1">
						{tClientLabels('claim.table.grossRetail')}
					</Typography>
				</TableCell>
				<TableCell align="center">
					<ClaimsOperationIcon sign={Sign.MINUS} />
				</TableCell>
				<TableCell align="center">
					<Typography variant="value1">
						{tClientLabels('claim.table.inStorePromotion')}
					</Typography>
				</TableCell>
				<TableCell align="center">
					<ClaimsOperationIcon sign={Sign.EQUAL} />
				</TableCell>
				<TableCell align="center">
					<Typography variant="value1">
						{tClientLabels('claim.table.retailAmount')}
					</Typography>
				</TableCell>
				{showTaxColumns && (
					<>
						<TableCell align="center">
							<ClaimsOperationIcon sign={Sign.ARROW} />
						</TableCell>
						<TableCell align="center">
							<Typography variant="value1">
								{tClientLabels('claim.table.retailNetOfTax')}
							</Typography>
						</TableCell>
						<TableCell align="center">
							<ClaimsOperationIcon sign={Sign.AND} />
						</TableCell>
						<TableCell align="center">
							<Typography variant="value1">
								{tClientLabels('claim.table.tax')}
							</Typography>
						</TableCell>
					</>
				)}
				<TableCell align="center">
					<ClaimsOperationIcon sign={Sign.MINUS} />
				</TableCell>
				<TableCell align="center">
					<Typography variant="value1">
						{tClientLabels('claim.table.contractaulAdjiustment')}
					</Typography>
				</TableCell>
				<TableCell align="center">
					<Typography variant="value1">
						{tClientLabels('claim.table.planPayment')}
					</Typography>
				</TableCell>
				<TableCell align="center">
					<ClaimsOperationIcon sign={Sign.PLUS} />
				</TableCell>
				<TableCell align="center">
					<Typography variant="value1">
						{tClientLabels('claim.table.memberOutOfPocket')}
					</Typography>
				</TableCell>
				<TableCell align="center">
					<ClaimsOperationIcon sign={Sign.EQUAL} />
				</TableCell>
				<TableCell align="center">
					<Typography variant="value1">
						{tClientLabels('claim.table.total')}
					</Typography>
				</TableCell>
			</TableRow>
		</TableHead>
	);
};

export default ClaimPaymentsHeader;
